import React from 'react';
import AnimatedSection from '../../components/blocks/AnimatedSection';
import { getJeltrEventBySlug } from '../../config/jeltrEvents';

const JELTR_CALL_SLUG = 'call-for-papers-2026';

const JELTR_MANUSCRIPT_TEMPLATE_HREF =
  'https://connecthkuhk-my.sharepoint.com/:w:/g/personal/u3606504_connect_hku_hk/IQAXs3FX1QcVSr-OzSCnlszwAUXFJXFWbbuHNOLNGzcah9w';

const CallForPapers2026 = () => {
  const event = getJeltrEventBySlug(JELTR_CALL_SLUG);

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          {event?.posterImage && (
            <div className="mb-8 flex justify-center">
              <img
                src={event.posterImage}
                alt={event.posterAlt || 'JELTR Call for Papers 2026 Poster'}
                className="w-auto h-auto max-w-md md:max-w-lg object-contain rounded-lg shadow-lg"
              />
            </div>
          )}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-4">
            JELTR Call for Papers 2026
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-4">
            Journal of Experiential Learning &amp; Transdisciplinary Research
          </p>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-4">
            Manuscript submissions for JELTR are now open. If you are an undergraduate seeking to give your research a platform, this is the perfect opportunity.
          </p>
          <p className="inline-block px-4 py-2 rounded-full bg-purple-100 text-purple-800 font-semibold text-sm">
            {event?.dateLabel || 'Submission deadline: 1 September 2026'}
          </p>
        </div>

        {/* Overview & Guidelines */}
        <AnimatedSection
          className="mb-16"
          heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Submission Guidelines</h2>}
        >
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-700 leading-relaxed text-justify mb-6">
              JELTR welcomes visionary academic manuscripts by undergraduate students that engage with experiential learning and transdisciplinary research.
            </p>
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-900">Manuscript requirements</h3>
              <ul className="list-disc list-inside space-y-2 text-lg text-gray-700">
                <li>Original work that has not been previously published.</li>
                <li>A full manuscript is required for review.</li>
                <li>
                  Manuscripts <span className="font-semibold">MUST</span> be submitted in{' '}
                  <span className="font-semibold">MICROSOFT WORD DOCUMENTS</span> and follow the template below.
                </li>
                <li>
                  Manuscripts with <span className="font-semibold">WRONG FORMATTING WILL NOT BE ENTERTAINED</span>.
                </li>
              </ul>
            </div>

            <div className="mt-6">
              <a
                href={JELTR_MANUSCRIPT_TEMPLATE_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-purple-400 hover:text-purple-600 transition text-center"
              >
                Open JELTR manuscript template (Microsoft Word)
              </a>
            </div>
          </div>
        </AnimatedSection>

        {/* Submission CTA */}
        <AnimatedSection
          className="mb-16"
          heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Submit Your Manuscript</h2>}
        >
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Ready to submit? Please prepare your manuscript according to the JELTR guidelines and upload it via the online form.
            </p>
            <a
              href={event?.ctaHref || 'https://forms.gle/HYF4mCfiHzueupJy7'}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 rounded-full border-2 border-purple-500 text-purple-700 font-semibold hover:bg-purple-50 transition"
            >
              {event?.ctaLabel || 'Submit Manuscript'}
            </a>
          </div>
        </AnimatedSection>
      </div>
    </div>
  );
};

export default CallForPapers2026;

